import React from 'react';
import './PageTabs.styles.scss';
import RegulatoryIcon from 'assets/icons/regulatory.svg';
import CompetitorsIcon from 'assets/icons/competitor.svg';
import PricingIcon from 'assets/icons/price.svg';
import RiskIcon from 'assets/icons/risk.svg';
import OverviewIcon from 'assets/icons/overview.svg';

interface PageTabsProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const PageTabs: React.FC<PageTabsProps> = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'overview', label: 'Overview', icon: OverviewIcon },
    { id: 'pricing', label: 'Pricing', icon: PricingIcon },
    { id: 'competitors', label: 'Competitors', icon: CompetitorsIcon },
    { id: 'manufacturer', label: 'Manufacturer', icon: RegulatoryIcon },
    { id: 'import-export', label: 'Import & Export', icon: RegulatoryIcon },
    { id: 'supply-risk', label: 'Supply Risk', icon: RiskIcon, disabled: true },
  ];

  const handleTabClick = (tabId: string, disabled?: boolean) => {
    if (!disabled) {
      onTabChange(tabId);
    }
  };

  return (
    <nav className="page-tabs">
      <div className="container">
        <ul className="tabs-nav">
          {tabs.map(tab => (
            <li key={tab.id}>
              <a
                href="#"
                className={`${activeTab === tab.id ? 'active' : ''} ${tab.disabled ? 'disabled' : ''}`}
                onClick={e => {
                  e.preventDefault();
                  handleTabClick(tab.id, tab.disabled);
                }}
                data-tab={tab.id}
              >
                <span className="tab-icon">
                  <img src={tab.icon} alt={tab.label} />
                </span>
                <span className="tab-label">{tab.label}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default PageTabs;
